module.exports = __webpack_public_path__ + "static/024.thumb-499205241d5a16ad6a10aa17c0b4e6b8.jpg";